import { createReducer } from "../../../_common/common.ts";
import { SET_HELP_MODE_STEP } from "../actions/constants";

const initialState = {
    helpModeStep: 0
};

const reducer = createReducer(initialState, {
    [SET_HELP_MODE_STEP]: (state, payload) => {
        return {
            ...state,
            helpModeStep: payload
        };
    },
});

export default reducer;
